import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import Form from 'components/Form';
import TextField from 'components/TextField';
import SeoRouteTypeSelect from 'components/SeoRouteTypeSelect';

import { useErrorHandler } from 'lib';

import {
  SeoRouteType,
  SeoRouteEditForm_seoRoute$key,
} from '__generated__/SeoRouteEditForm_seoRoute.graphql';

type FormFields = {
  type: SeoRouteType;
  sourceUrl: string;
  targetUrl: string;
};

type Props = {
  seoRoute: SeoRouteEditForm_seoRoute$key;
};

const SeoRouteEditForm: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, type, sourceUrl, targetUrl } = useFragment(
    graphql`
      fragment SeoRouteEditForm_seoRoute on SeoRoute {
        id
        type
        sourceUrl
        targetUrl
      }
    `,
    props.seoRoute
  );

  const [update, updating] = useMutation(graphql`
    mutation SeoRouteEditFormMutation($id: ID!, $input: UpdateSeoRouteInput!) {
      updateSeoRoute(id: $id, input: $input) {
        ...SeoRouteSidebar_seoRoute
        ...SeoRouteEditForm_seoRoute
      }
    }
  `);

  const initial = {
    type,
    sourceUrl: sourceUrl ?? '',
    targetUrl: targetUrl ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormFields) => {
      update({
        variables: { id, input },
        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="seoRouteEdit">
          <Section id="main" title="Bendra informacija">
            <Stack spacing={4}>
              <SeoRouteTypeSelect name="type" />
              <TextField fullWidth name="sourceUrl" label="Ateinantis URL" />
              <TextField fullWidth name="targetUrl" label="Redirect URL" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default SeoRouteEditForm;
